export const formValues = {
    situation: "",
    experienceYears: "",
    sex: "",
    birthday: "",
    prefecture: null,
    city: null,
    firstName: "",
    lastName: "",
    firstNameKana: "",
    lastNameKana: "",
    tel: "",
    lineId: "",
    email: "",
    password: "",
    userResumesAttributes: {
        0: {
            companyName: "",
            employmentId: null,
            genreId: null,
            occupationIds: null,
            detailedJobDetails: "",
            workStartYear: "",
            workStartMonth: "",
            workEndDateYear: null,
            workEndDateMonth: null,
            userOccupationResumesAttributes: [{ occupationId: null }],
        },
    },
    mailMagazine: 0,
    agentService: 0,
}

export const displayValues = {
    situation: "",
    prefectureCity: "",
    name: "",
    nameKana: "",
    birthday: "",
    sex: "",
    tel: "",
    lineId: "",
    email: "",
    password: "",
    companyName: "",
    workStartDate: "",
    workEndDate: null,
    experienceYears: "",
    employment: null,
    genre: null,
    occupation: null,
    detailedJobDetails: "",
}
